<div class="row">
  <div class="col">
    <form [formGroup]="form">
      <h3 class="my-4">{{'nav.masterData' | translate}}</h3>
      <div class="row">
        <div class="col-6">
          <div class="form-group validateMe">
            <label for="Name" class="form-label">{{'lang.globals.title' | translate}}
            </label>
            <input type="text" id="Name" class="form-control" formControlName="Name">
          </div>
        </div>
        <div class="col-6">
          <label for="blankcustselacnv" class="form-label">{{'lang.globals.customer' | translate}}
          </label>
          <div id="blankcustselacnv" style="margin-bottom: -1.5rem;">&nbsp;</div>
          <sb-comp-dropdown-select
            *ngIf="permissionService.hasPermission(permissionService.Permission.company_list)"
            [showColumnIcon]="false" [showSubmit]="false" [singleSelectMode]="true"
            (msOptionsChange)="msRequest('COMPANIES', $event)" [msOptions]="msCompanyOptions"
            (selectedDataEmitter)="update($event, 'COMPANIES')" [dropDownDatatype]="'COMPANIES'"
            [inputData]="companies" [selectedInputData]="company ? [company] : []">
          </sb-comp-dropdown-select>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="row">
  <div class="col">
    <div class="d-flex flex-row">
      <div
        class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
        <p class="w-100 tr"></p>
        <p class="w-100 tr">
          <button class="btn btn-primary mr-2" (click)="ok()">{{'lang.globals.ok' | translate}}</button>
          <button class="btn btn-secondary" (click)="cancel()">{{'lang.globals.cancel' | translate}}</button>
        </p>
      </div>
    </div>
  </div>
</div>
